<template>
    <div>
        <div id="content" class="content animated slideInRight delay-1s">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                Status de Veículo
                                <span class="required_fields text-white"><span class="required">*</span> Campos obrigatórios</span>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <form id="form">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="description"><span class="required">*</span> Descrição:</label>
                                                    <input type="text" class='form-control' v-model="vehicleStatus.description">
                                                </div>
                                            </div>
										</div>
                                        <hr>
                                        <div class="block text-right">
                                            <a class="btn btn-add" @click="save">
                                                Salvar <i class="fa fa-save ml-2"></i>
                                            </a>
                                            <router-link to="/vehicleStatus" class="btn btn-back">
                                                <i class="fa fa-arrow-left mr-2"></i> Voltar
                                            </router-link>
                                        </div>
                                    </form>
                                </div>
                            </div>
						</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'

    export default {
        data() {
            return {
                vehicleStatus: {
                    description:''
                }
            }
        },
        computed: {

        },
        methods: {
            makeFormData: function(){
                const self = this;
                let fd  = new FormData();

                fd.append('description', self.vehicleStatus.description);

                if(self.vehicleStatus.id){
                    fd.append('id', self.vehicleStatus.id);
                    fd.append('_method', 'PUT');
                }

                return fd;
            },
            save: function () {
                const self = this;
                let api = self.$store.state.api + 'vehicleStatus';

                let fd = self.makeFormData();

                if(self.vehicleStatus.id){
                    api += '/' + self.vehicleStatus.id;
                }

                self.$http.post(api, fd)
                    .then((response) => {
                        self.$message('Sucesso', `Informações guardadas com sucesso`, 'success');
                        this.$router.push('/vehicleStatus');
                    })
                    .catch((error) => {
                        self.$message(null, error.response.data, 'error');
                    });
            },
            getVehicleStatus: function (id) {
                const self = this;
                const api = self.$store.state.api + 'vehicleStatus/' + id;

                self.$http.get(api)
                    .then((response) => {
                        self.vehicleStatus = response.data.data[0]
                    })
                    .catch((error) => {
                        self.$message(null, error.response.data, 'error');
                    });
            },
        },
        mounted: function(){
            const self = this;

            let id = self.$route.params.id;
            if(id){
                self.getVehicleStatus(id);
            }
        },
        components: {
            BaseCrud
        }
    }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/VehicleStatus/Add.vue